module.exports = __webpack_public_path__ + "public/Icons/languageIcon.svg?a16bcb1e";